export default __webpack_public_path__ + "static/media/agrement.d480cc6f.pdf";